import {ModuleWithProviders} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {RequisitionListComponent} from './requisition-list.component';

const routes: Routes = [
    {
        path: '', component: RequisitionListComponent
    }
];
export const routing: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/blood-transfusion/requisition-list/requisition-list.routing.ts